import { slice } from './slice';

const { reducer } = slice;

export * from './thunks';
export * as chatsUserInitSelectors from './selectors';

export default reducer;
